export default __webpack_public_path__ + "static/6aebdcf23ec56c32e0187958d78d8d45.png";